module.exports = __webpack_public_path__ + "media/bootstrap-icons/droplet-half-a458af06.svg";